import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const KEY = "tb-cookie-consent-v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const set = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
      className="fixed inset-x-3 bottom-3 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-50"
    >
      <div className="bg-white border border-[var(--tb-border)] rounded-2xl shadow-xl p-5 md:p-6">
        <div className="flex items-start gap-3">
          <span className="grid place-items-center h-9 w-9 rounded-full bg-[var(--tb-surface)] text-[var(--tb-primary)] shrink-0">
            <Cookie className="h-4 w-4" />
          </span>
          <div className="flex-1">
            <h3 className="font-serif-display text-lg text-[var(--tb-text)] mb-1">A note about cookies</h3>
            <p className="text-sm text-[var(--tb-text-2)]">
              We use essential cookies to keep the site working, and optional analytics cookies to help us understand how
              the site is used. Read our{" "}
              <a href="/privacy" className="underline text-[var(--tb-primary)] hover:no-underline">privacy policy</a>.
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <button
                data-testid="cookie-accept-button"
                onClick={() => set("accepted")}
                className="rounded-full bg-[var(--tb-primary)] hover:bg-[var(--tb-primary-hover)] text-white px-4 py-2 text-sm font-semibold"
              >
                Accept all
              </button>
              <button
                data-testid="cookie-essential-button"
                onClick={() => set("essential")}
                className="rounded-full border border-[var(--tb-border)] bg-white text-[var(--tb-text-2)] hover:border-[var(--tb-primary)] hover:text-[var(--tb-primary)] px-4 py-2 text-sm font-semibold"
              >
                Essential only
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
